import {
  STATIC_PERMISSIONS,
  STATIC_PERMISSION_KEYS,
  groupDeletePerm,
  groupUploadPerm,
} from '@uchat-team-management/shared';

export interface PermissionEntry {
  key: string;
  label: string;
  description: string;
}

export interface PermissionSection {
  title: string;
  entries: PermissionEntry[];
}

const groupFileDescription = (action: 'Upload' | 'Delete', name: string) =>
  `${action} files in the ${name} group on devices assigned to you (or any device with "Access all device files").`;

/**
 * Groups the catalogue for the picker: static keys by domain prefix, then one
 * "Device files" section with the dynamic per-group keys derived from slugs.
 */
export const permissionSections = (
  groups: { slug: string; name: string }[],
): PermissionSection[] => {
  const byDomain = new Map<string, PermissionEntry[]>();
  for (const key of STATIC_PERMISSION_KEYS) {
    const domain = key.split(':')[0] as string;
    const meta = STATIC_PERMISSIONS[key];
    const entry = { key, label: meta.label, description: meta.description };
    const list = byDomain.get(domain);
    if (list) list.push(entry);
    else byDomain.set(domain, [entry]);
  }
  const sections: PermissionSection[] = [...byDomain.entries()].map(([domain, entries]) => ({
    title: domain.charAt(0).toUpperCase() + domain.slice(1),
    entries,
  }));
  if (groups.length > 0) {
    sections.push({
      title: 'Device files',
      entries: groups.flatMap((g) => [
        {
          key: groupUploadPerm(g.slug),
          label: `Upload — ${g.name}`,
          description: groupFileDescription('Upload', g.name),
        },
        {
          key: groupDeletePerm(g.slug),
          label: `Delete — ${g.name}`,
          description: groupFileDescription('Delete', g.name),
        },
      ]),
    });
  }
  return sections;
};
